<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span>Создание новости</span>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div>
          <v-text-field
            label="Заголовок"
            required
            type="text"
            outlined
            :rules="rules"
            counter
            v-model="news.name"
            maxlength="100"
          ></v-text-field>
        </div>
        <div>
          <v-select
            multiple
            deletable-chips
            small-chips
            :items="categories"
            outlined
            item-text="name"
            item-value="id"
            :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']"
            v-model="news.categories"
            label="Категории"
          ></v-select>
        </div>

        <div
          style="margin-bottom: 30px"
          class="trumbowyg-title-box"
          :class="validText ? '' : 'trumbowyg-title-box-error'"
        >
          <div class="trumbowyg-title-box-text">Текст HTML</div>
          <trumbowyg
            v-model="news.fullText"
            :config="{ semantic: false }"
          ></trumbowyg>
        </div>

        <div>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newDate"
                outlined
                :rules="rules"
                readonly
                label="Дата публикации"
                v-bind="attrs"
                v-on="on"
                ref="date_input"
              ></v-text-field>
            </template>
            <v-card class="d-flex">
              <div class="d-flex">
                <!-- :min="new Date().toISOString().substr(0, 10)" -->
                <v-date-picker
                  locale="ru-Ru"
                  color="var(--app-dark-blue-1)"
                  v-model="pickDate"
                  first-day-of-week="1"
                ></v-date-picker>
                <v-time-picker
                  format="24hr"
                  color="var(--app-dark-blue-1)"
                  scrollable
                  :disabled="!pickDate"
                  v-model="pickDateTime"
                  width="290"
                ></v-time-picker>
                <!-- :allowed-hours="checkTimeHour"
                  :allowed-minutes="checkTimeMinute" -->
              </div>
            </v-card>
          </v-menu>
        </div>
      </div>
    </v-form>

    <div class="container-block">
      <div class="container-block-title" style="margin-top: 0">
        Вид перехода из новости
      </div>
      <v-radio-group mandatory v-model="news.transitionType" row>
        <v-radio
          color="var(--app-dark-blue-1)"
          label="Нет перехода"
          :value="null"
        ></v-radio>
        <v-radio
          color="var(--app-dark-blue-1)"
          label="Ссылка"
          value="url"
        ></v-radio>
        <v-radio
          color="var(--app-dark-blue-1)"
          label="PDF Файл"
          value="file"
        ></v-radio>
        <v-radio
          color="var(--app-dark-blue-1)"
          label="Внутренний раздел"
          value="deeplink"
        ></v-radio>
      </v-radio-group>
      <div v-if="news.transitionType == null">
        <v-form lazy-validation ref="notForm"> </v-form>
      </div>
      <div v-else-if="news.transitionType == 'deeplink'">
        <v-form lazy-validation ref="formDeepLink">
          <v-select
            :items="sections"
            outlined
            item-text="name"
            item-value="key"
            :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']"
            v-model="news.appSectionKey"
            label="Выберите раздел для перехода"
          ></v-select>

          <v-text-field
            label="Название кнопки"
            required
            type="text"
            outlined
            :rules="rules"
            v-model="news.buttonName"
          ></v-text-field>
        </v-form>
      </div>
      <div v-else-if="news.transitionType == 'file'">
        <v-form lazy-validation ref="formPDF">
          <v-file-input
            outlined
            show-size
            v-model="news.newTransitionFile"
            label="Прикрепите файл pdf"
            :rules="[
              (value) =>
                (value && value.size < 104857600) ||
                'Размер pdf не больше 100 мб',
            ]"
            hint="Максимальный размер pdf 100 Мб"
            persistent-hint
            accept="application/pdf,application/vnd.ms-excel"
          >
          </v-file-input>
        </v-form>
      </div>

      <div v-else>
        <v-form lazy-validation ref="formLink">
          <v-text-field
            label="Ссылка"
            required
            type="text"
            outlined
            :rules="[
              (v) => !!v || 'Обязательно к заполнению',
              (v) => checkValidUrl(v) || '',
            ]"
            v-model="news.path"
          ></v-text-field>
          <v-checkbox
            class="container-main-checkbox pt-5"
            color="var(--app-dark-blue-1)"
            v-model="news.isWebView"
            label="Открыть WebView (ссылка откроется внутри приложения)"
          ></v-checkbox>
        </v-form>
      </div>
    </div>
    <div class="container-block">
      <div class="container-block-title">
        Параметры публикации и отображения
      </div>
      <div class="d-flex align-center">
        <v-switch
          :disabled="!news.toShowInNews"
          hide-details
          v-model="news.toHead"
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label"
          >Главная новость - Первая в списке и с большим изображением</span
        >
      </div>

      <div class="d-flex align-center mt-4">
        <v-switch
          v-model="news.toShowOnMainScreen"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">Отображать на главном экране</span>
        <v-icon
          @mouseover="
            ($event) => {
              showMainNewsInfo = true;
              openInfo($event);
            }
          "
          @mouseleave="showMainNewsInfo = false"
          color="var(--app-dark-blue-1)"
          >mdi-information</v-icon
        >
      </div>
      <v-menu
        v-model="showMainNewsInfo"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
      >
        <v-card min-width="300px" min-height="80px">
          <div class="menu-container">
            <div class="menu-container-text mb-0">
              Настройка <strong>"Корпоративные новости"</strong> в профиле
              пользователя в приложении
            </div>
          </div>
        </v-card>
      </v-menu>

      <div class="d-flex align-center mt-4">
        <v-switch
          v-model="news.toShowInNews"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">Отображать в разделе "Новости"</span>
        <v-icon
          @mouseover="
            ($event) => {
              showNewsSectionInfo = true;
              openInfo($event);
            }
          "
          @mouseleave="showNewsSectionInfo = false"
          color="var(--app-dark-blue-1)"
          >mdi-information</v-icon
        >
      </div>
      <v-menu
        v-model="showNewsSectionInfo"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
      >
        <v-card min-width="300px" min-height="80px">
          <div class="menu-container">
            <div class="menu-container-text mb-0">
              Настройка <strong>"Новостная лента"</strong> в профиле
              пользователя в приложении
            </div>
          </div>
        </v-card>
      </v-menu>

      <div class="d-flex align-center mt-4">
        <v-switch
          v-model="news.toShowInConference"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label">Выводить на сайте конференции</span>
      </div>
      <!-- <div class="d-flex align-center">
                <v-switch
                    v-model="news.isTimezoneRequired"
                    color="var(--app-green-1)"
                    ></v-switch>
                    <span class="switch-label">Учитывать временные зоны</span>
             </div> -->
    </div>
    <div class="container-block">
      <div class="container-block-title">Уведомление</div>

      <div class="d-flex flex-column mb-4">
        <div class="d-flex align-center mb-4">
          <v-switch
            v-model="news.mustSendPush"
            color="var(--app-green-1)"
            @change="infoPush"
            hide-details
          ></v-switch>
          <span class="switch-label"
            >Отправить Push-уведомление при публикации новости</span
          >
        </div>
        <span class="switch-hint"
          >Push-уведомление будет отправлено при публикации новости. Отправка
          уведомления возможна 1 раз. Для повторной отправки необходимо создать
          новость заново.</span
        >
      </div>
      <v-form lazy-validation ref="sendPush">
        <v-text-field
          v-if="news.mustSendPush"
          label="Заголовок"
          required
          type="text"
          outlined
          :rules="rules"
          counter
          maxlength="65"
          v-model="news.pushTitle"
        ></v-text-field>
        <v-text-field
          v-if="news.mustSendPush"
          label="Описание"
          required
          type="text"
          outlined
          :rules="rules"
          counter
          maxlength="240"
          v-model="news.pushDescription"
        ></v-text-field>
      </v-form>
    </div>

    <div v-if="!newImage" class="container-block">
      <div class="container-block-title">Главное изображение</div>

      <v-file-input
        accept="image/*"
        outlined
        :rules="[
          (value) =>
            (value && value.size < 104857600) ||
            'Размер изображения не больше 100 мб',
        ]"
        hint="Максимальный размер изображения 100 мб"
        persistent-hint
        v-model="newImage"
        @change="previewImage"
        label="Прикрепить изображение"
      ></v-file-input>
      <div class="container-block-gallery-button">
        Выбрать изображение из галереи
      </div>
    </div>

    <div v-if="!newImageMini" class="container-block">
      <div class="container-block-title">Миниатюра</div>

      <v-file-input
        accept="image/*"
        outlined
        :rules="[
          (value) =>
            (value && value.size < 104857600) ||
            'Размер изображения не больше 100 мб',
        ]"
        hint="Максимальный размер изображения 100 мб"
        persistent-hint
        v-model="newImageMini"
        @change="previewImageMini"
        label="Прикрепить изображение"
      ></v-file-input>
      <div class="container-block-gallery-button">
        Выбрать изображение из галереи
      </div>
    </div>

    <div></div>

    <div
      v-if="newImage || newImageMini"
      class="container-block"
      style="width: 100%"
    >
      <div class="container-block-title">Кадрировать изображение</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Для смартфонов</th>
              <th class="text-left">Для планшетов</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px" v-if="newImage">
              <td class="text-left">Главное изображение</td>
              <td class="text-left">Отображается на всплывающем окне</td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageMobile"
                  @click="openMobileImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img
                    @click="openMobileImg(false)"
                    class="table-img"
                    :src="finishImageMobile"
                  />
                  <v-btn
                    outlined
                    @click="openMobileImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageTablet"
                  @click="openTabletImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img
                    @click="openTabletImg(false)"
                    class="table-img"
                    :src="finishImageTablet"
                  />
                  <v-btn
                    outlined
                    @click="openTabletImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
            <tr style="height: 60px" v-if="newImageMini">
              <td class="text-left">Миниатюра</td>
              <td class="text-left">Отображается на всплывающем окне</td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageMobileMini"
                  @click="openMobileImg(true)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img
                    @click="openMobileImg(true)"
                    class="table-img"
                    :src="finishImageMobileMini"
                  />
                  <v-btn
                    outlined
                    @click="openMobileImg(true)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageTabletMini"
                  @click="openTabletImg(true)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img
                    @click="openTabletImg(true)"
                    class="table-img"
                    :src="finishImageTabletMini"
                  />
                  <v-btn
                    outlined
                    @click="openTabletImg(true)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImageMini">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображения для всех типов устройств
      </v-alert>
      <v-divider></v-divider>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogMobile"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobile = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper
                  ref="cropperMobail"
                  :src="imgSrc"
                  style="width: 450px; height: 450px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :canvas="{
                    maxHeight: 600,
                    maxWidth: 1200,
                  }"
                  :stencil-size="{
                    width: 343,
                    height: 173,
                  }"
                  image-restriction="stencil"
                  @change="onChangeMobile"
                />
              </div>

              <div v-if="resultImageMobile">
                <img
                  width="343px"
                  height="173px"
                  style="margin-left: 30px"
                  :src="resultImageMobile"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrcMini"
        v-model="dialogMobileMini"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobileMini = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrcMini" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper
                  ref="cropperMobailMini"
                  :src="imgSrcMini"
                  style="width: 450px; height: 450px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :canvas="{
                    maxHeight: 600,
                    maxWidth: 1200,
                  }"
                  :stencil-size="{
                    width: 84,
                    height: 84,
                  }"
                  image-restriction="stencil"
                  @change="onChangeMobileMini"
                />
              </div>

              <div
                style="width: 100%"
                class="d-flex justify-center"
                v-if="resultImageMobileMini"
              >
                <img width="84px" height="84px" :src="resultImageMobileMini" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImgMini()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogTablet"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTablet = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="">
              <div style="width: 100%; height: 200px">
                <cropper
                  ref="cropperTablet"
                  :src="imgSrc"
                  style="width: 100%; height: 300px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :canvas="{
                    maxHeight: 1200,
                    maxWidth: 2400,
                  }"
                  :stencil-size="{
                    width: 658,
                    height: 374,
                  }"
                  image-restriction="stencil"
                  @change="onChangeTablet"
                />
              </div>

              <div class="dialog-tablet-img" v-if="resultImageTablet">
                <img width="658px" height="374px" :src="resultImageTablet" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrcMini"
        v-model="dialogTabletMini"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTabletMini = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrcMini" class="">
              <div style="width: 100%; height: 200px">
                <cropper
                  ref="cropperTabletMini"
                  :src="imgSrcMini"
                  style="width: 100%; height: 300px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :canvas="{
                    maxHeight: 1200,
                    maxWidth: 2400,
                  }"
                  :stencil-size="{
                    width: 322,
                    height: 185,
                  }"
                  image-restriction="stencil"
                  @change="onChangeTabletMini"
                />
              </div>

              <div class="dialog-tablet-img" v-if="resultImageTabletMini">
                <img
                  width="322px"
                  height="185px"
                  :src="resultImageTabletMini"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImgMini()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn
          @click="saveNews"
          :loading="sendForm"
          style="width: auto !important"
          class="button-accept"
        >
          Сохранить
        </v-btn>
      </div>
      <div></div>
    </div>
    <transition name="fade">
      <v-alert
        v-if="errorAlert"
        class="error-alert"
        color="var(--app-red-1)"
        type="error"
      >
        Новость с таким заголовком или текстом уже существует
      </v-alert>
    </transition>
  </div>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    Cropper,
  },
  data: () => ({
    errorAlert: false,
    showNewsSectionInfo: false,
    showMainNewsInfo: false,
    x: null,
    y: null,
    news: {
      mustSendPush: false,
      isWebView: false,
      toHead: false,
      fullText: "",
      isTimezoneRequired: false,
      toShowOnMainScreen: false,
      toShowInNews: false,
      toShowInConference: false,
    },
    pickDateTime: "00:00",
    dates: [],
    newDate: null,
    pickDate: null,
    text: "",
    validText: true,
    categories: [],
    fileSrc: "",
    errImages: false,
    errImagesMain: false,
    dialogMobile: false,
    dialogMobileMini: false,
    dialogTablet: false,
    dialogTabletMini: false,
    dateFormatted: null,
    menu: false,
    sections: [],

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    newImageMini: null,

    imgSrc: "",
    imgSrcMini: "",

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",

    resultImageMobileMini: "",
    resultImageTabletMini: "",

    finishImageMobileMini: "",
    finishImageTabletMini: "",

    smartphoneMainImage: null,
    tabletMainImage: null,

    smartphoneMiniImage: null,
    tabletMiniImage: null,
    formData: new FormData(),
    sendForm: false,

    lastSelectionContainDel: false,
    lastTargetedSelectionEvent: null,
    lastTrumbowygSelection: null,
  }),

  methods: {
    infoPush() {
      this.news.pushTitle = this.news.name;
    },
    openInfo(e) {
      e.preventDefault();
      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
    },
    checkTimeHour(hour) {
      if (new Date().toISOString().substr(0, 10) == this.pickDate) {
        return hour >= new Date().getHours();
      } else {
        return hour + 1;
      }
    },
    checkTimeMinute(minute) {
      if (
        new Date().toISOString().substr(0, 10) == this.pickDate &&
        new Date().getHours() == parseInt(this.pickDateTime.substr(0, 2))
      ) {
        return minute >= new Date().getMinutes() && minute % 1 === 0;
      } else {
        return minute % 1 === 0;
      }
    },
    getAppSections() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/appSection/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.sections = res.data.items.filter((i) => {
            if (!i.isRemovable) {
              return i;
            }
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    deleteImage() {
      this.newImage = null;
      this.imgSrc = "";
      this.resultImageMobile = "";
      this.resultImageTablet = "";
      this.finishImageMobile = "";
      this.finishImageTablet = "";
      this.smartphoneMainImage = null;
      this.tabletMainImage = null;
    },
    deleteImageMini() {
      this.newImageMini = null;
      this.imgSrcMini = "";
      this.resultImageMobileMini = "";
      this.resultImageTabletMini = "";
      this.finishImageMobileMini = "";
      this.finishImageTabletMini = "";
      this.smartphoneMiniImage = null;
      this.tabletMiniImage = null;
    },
    openMobileImg(mini) {
      if (mini) {
        this.dialogMobileMini = true;
        setTimeout(() => {
          this.$refs.cropperMobailMini.refresh();
        }, 500);
      } else {
        this.dialogMobile = true;
        setTimeout(() => {
          this.$refs.cropperMobail.refresh();
        }, 500);
      }

      this.errImages = false;
    },
    openTabletImg(mini) {
      if (mini) {
        this.dialogTabletMini = true;
        setTimeout(() => {
          this.$refs.cropperTabletMini.refresh();
        }, 500);
      } else {
        this.dialogTablet = true;
        setTimeout(() => {
          this.$refs.cropperTablet.refresh();
        }, 500);
      }

      this.errImages = false;
    },
    closeTabletImg() {
      this.finishImageTablet = this.resultImageTablet;
      this.dialogTablet = false;
      const { canvas } = this.$refs.cropperTablet.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("tabletMainImage")) {
            this.formData.delete("tabletMainImage");
          }
          this.formData.append("tabletMainImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletMainImage = true;
    },
    closeTabletImgMini() {
      this.finishImageTabletMini = this.resultImageTabletMini;
      this.dialogTabletMini = false;
      const { canvas } = this.$refs.cropperTabletMini.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("tabletMiniImage")) {
            this.formData.delete("tabletMiniImage");
          }
          this.formData.append("tabletMiniImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletMiniImage = true;
    },
    closeMobileImg() {
      this.finishImageMobile = this.resultImageMobile;
      this.dialogMobile = false;
      const { canvas } = this.$refs.cropperMobail.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("smartphoneMainImage")) {
            this.formData.delete("smartphoneMainImage");
          }
          this.formData.append("smartphoneMainImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneMainImage = true;
    },
    closeMobileImgMini() {
      this.finishImageMobileMini = this.resultImageMobileMini;
      this.dialogMobileMini = false;
      const { canvas } = this.$refs.cropperMobailMini.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("smartphoneMiniImage")) {
            this.formData.delete("smartphoneMiniImage");
          }
          this.formData.append("smartphoneMiniImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneMiniImage = true;
    },
    back() {
      this.$router.push({ name: "News" });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    previewImage() {
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
      }
    },
    previewImageMini() {
      if (this.newImageMini) {
        this.imgSrcMini = URL.createObjectURL(this.newImageMini);
      } else {
        this.imgSrcMini = "";
      }
    },

    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    onChangeMobile({ canvas }) {
      this.resultImageMobile = canvas.toDataURL();
    },
    onChangeMobileMini({ canvas }) {
      this.resultImageMobileMini = canvas.toDataURL();
    },
    onChangeTablet({ canvas }) {
      this.resultImageTablet = canvas.toDataURL();
    },
    onChangeTabletMini({ canvas }) {
      this.resultImageTabletMini = canvas.toDataURL();
    },
    getCategoryList() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/category/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.categories = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    saveNews() {
      if (this.$refs.formFirst.validate() && this.validText) {
        let formType = null;
        if (this.news.transitionType == "url") {
          formType = this.$refs.formLink;
        } else if (this.news.transitionType == "deeplink") {
          formType = this.$refs.formDeepLink;
        } else if (this.news.transitionType == "file") {
          formType = this.$refs.formPDF;
        } else if (this.news.transitionType == null) {
          formType = this.$refs.notForm;
        }

        if (formType.validate()) {
          const checkPush = this.news.mustSendPush
            ? this.$refs.sendPush.validate()
            : true;
          if (checkPush) {
            if (this.newImage && this.newImageMini) {
              if (
                this.smartphoneMainImage &&
                this.tabletMainImage &&
                this.smartphoneMiniImage &&
                this.tabletMiniImage
              ) {
                this.errImages = false;
                this.sendForm = true;
                const validDate = this.pickDate + "T" + this.pickDateTime;
                const date = new Date(validDate).getTime();
                this.formData.append("name", this.news.name || "");
                this.formData.append("datePublished", date);
                this.formData.append("fullText", this.news.fullText);
                this.formData.append(
                  "categories",
                  JSON.stringify(this.news.categories?.filter(Boolean))
                );

                this.formData.append("toHead", this.news.toHead);
                this.formData.append(
                  "transitionType",
                  this.news.transitionType
                );
                this.formData.append("mustSendPush", this.news.mustSendPush);
                this.formData.append(
                  "toShowOnMainScreen",
                  this.news.toShowOnMainScreen
                );
                this.formData.append(
                  "toShowInConference",
                  this.news.toShowInConference
                );

                this.formData.append("toShowInNews", this.news.toShowInNews);

                this.formData.append(
                  "isTimezoneRequired",
                  this.news.isTimezoneRequired
                );
                if (this.news.mustSendPush) {
                  this.formData.append("pushTitle", this.news.pushTitle);
                  this.formData.append(
                    "pushDescription",
                    this.news.pushDescription
                  );
                }

                if (this.news.transitionType == "url") {
                  this.formData.append("path", this.news.path);
                  this.formData.append("isWebView", this.news.isWebView);
                }
                if (this.news.transitionType == "deeplink") {
                  this.formData.append(
                    "appSectionKey",
                    this.news.appSectionKey
                  );
                  this.formData.append("buttonName", this.news.buttonName);
                }
                if (
                  this.news.transitionType == "file" &&
                  this.news.newTransitionFile
                ) {
                  this.formData.append(
                    "file",
                    this.news.newTransitionFile || ""
                  );
                }

                this.formData.append("mainImage", this.newImage || null);

                this.formData.append("miniImage", this.newImageMini || null);
                this.$axios
                  .post(
                    this.$store.getters.apiAdminPanelV5 + "/news",
                    this.formData,
                    {
                      headers: {
                        "secret-key": this.$store.state.secretKeyCookie,
                        authorization: this.$store.getters.adminPanelHeaderAuth,
                      },
                    }
                  )

                  .then(() => {
                    this.sendForm = false;
                    this.$router.push({ name: "News" });
                  })
                  .catch((err) => {
                    this.sendForm = false;
                    this.clearFormDataContextCreatedInSave();
                    if (err.response.data.err == "content_already_exists") {
                      this.errorAlert = true;
                      setTimeout(() => {
                        this.errorAlert = false;
                      }, 5000);
                    }
                  });
              } else {
                this.errImages = true;
              }
            } else {
              this.errImagesMain = true;
            }
          }
        }
      } else {
        if (!this.news.fullText) {
          this.validText = false;
        }
      }
    },
    clearFormDataContextCreatedInSave() {
      [...this.formData.entries()].forEach(([key, _]) => {
        key.startsWith("smart") || key.startsWith("tablet")
          ? ""
          : this.formData.delete(key);
      });
    },
  },
  created() {
    this.getAppSections();
    this.getCategoryList();
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
    newImageMini() {
      if (this.newImageMini) {
        this.errImagesMain = false;
      }
    },
    pickDate() {
      const date = this.formatDate(this.pickDate);
      this.newDate = date + " " + this.pickDateTime;
    },
    pickDateTime() {
      if (this.pickDate) {
        const date = this.formatDate(this.pickDate);
        this.newDate = date + " " + this.pickDateTime;
      }
    },
    "news.fullText"() {
      if (this.news.fullText) {
        this.validText = true;
      } else {
        this.validText = false;
      }
    },
    "news.toShowInNews"() {
      if (!this.news.toShowInNews) {
        this.news.toHead = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.trumbowyg-title-box {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 4px;
  padding: 2px;
}

.trumbowyg-title-box-error {
  border: 2px solid red !important;
}

.trumbowyg-title-box-text {
  font-size: 16px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  height: 50px;
}

.switch-label {
  font-size: 16px;
  color: #0000009a;
  margin-right: 12px;
}
.switch-hint {
  color: #6b7683;
  font-size: 14px;
  font-weight: 400;
}

.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
      margin-top: 30px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }

    .container-main-checkbox {
      border: 1px solid rgb(224, 224, 224);
      border-radius: 4px;
      padding-top: 20px;
      padding-left: 12px;
      margin-top: 0px !important;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.error-alert {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 100;
  max-width: 510px;
  transition: 0.5s;
}
</style>
